/**
 * Texts for Training page
 */
export const trainingPageText = {
    title: 'Szkolenie — aplikacja CamAPS FX',
    titleMeta: 'Zapewniamy bezpłatne szkolenie online dla użytkowników aplikacji CamAPS FX',
    descriptionMeta: 'W ramach programu Cambridge Diabetes Education Programme odbywają się bezpłatne certyfikowane szkolenia online przeznaczone dla osób z cukrzycą typu 1, ich rodziców i opiekunów, personelu szkolnego i personelu medycznego.',
    keywords: 'trening camaps, trening camaps fx,  ',
    localeMeta: 'pl_pl',
    mainHeader: 'Szkolenie medyczne',
    mainSubHeader: 'Wspieraj osoby korzystające z CamAPS FX dzięki szkoleniom prowadzonym przez ekspertów.',
    gettingStartedHeader: 'Rozpoczęcie',
    step1Title: '<strong>Krok 1:</strong><br/>Pobierz aplikację',
    step2Title: '<strong>Krok 2:</strong><br/>Utwórz konto',
    step3Title: '<strong>Krok 3:</strong><br/>Rozpocznij niezbędne szkolenie w aplikacji',
    step4Title: '<strong>Krok 4:</strong><br/>Sparuj z wybraną pompą i CGM (za zgodą zespołu opieki zdrowotnej) lub poznaj aplikację w <strong>trybie wirtualnym</strong>',
    videoSrc: '/video/In-app training loop_1.mp4',
    certifiedTrainingTitle: 'Certyfikowane szkolenie',
    trainingHeader: 'Certyfikowane szkolenie',
    trainingHeader_2: 'Dla personelu medycznego',
    trainingHeader_3: 'Szkolenie użytkowników',
    trainingHeaderText: 'BEZPŁATNE szkolenie online dotyczące aplikacji CamAPS FX organizowane w ramach programu Cambridge Diabetes Education Programme (CDEP).',
    websiteLink: 'https://www.camdiabtraining.com/account-sign-in.html',
    websiteLinkHeading: 'Szkolenie CDEP',
    getTrained: 'Weź udział w szkoleniu',
    trainingHeaderIat: 'Szkolenie CamAPS FX',
    trainingHeaderTextIat: 'Ukończ podstawowe szkolenie w aplikacji przed użyciem aplikacji CamAPS FX.',
    trainingSubHeaderOneIat: 'Pierwsze kroki',
    trainingSubTextOneIat: 'Pobierz aplikację CamAPS FX. <br>Załóż konto, aby rozpocząć szkolenie.',
    trainingSubHeaderTwoIat: 'Potrzebujesz pomocy przy instalacji aplikacji?',
    trainingParaTwoStartIat: 'Odwiedź naszą',
    trainingParaTwoEndIat: 'sekcję z poradami.',
    websiteLinkHeadingSupportIat: 'Wsparcie',
    trainingSubHeaderThreeIat: 'Dodatkowe zasoby',
    animationsYpsoPumpText: 'Animacje',
    animationsAndText: 'i',
    animationsDanaText: 'Animacje (pompa Dana)',
    animationsFurtherText: 'Ucz się dzięki wizualizacjom krok po kroku.',
    webinarsText: 'Webinaria',
    webinarsFurtherText: 'Obejrzyj sesje prowadzone przez ekspertów o korzystaniu z aplikacji.',
    websiteAnimationsYpsoPumpLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    websiteAnimationsDanaLink: 'https://www.camdiabtraining.com/view/25/Dana-insulin-pump-users.htm',
    websiteWebinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
};
